import { IForegroundSize, IImageSize, ImageRelativeResizeType, IOriginalSize } from './image-size.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { transaction } from '@src/slide/domain/slide-app';
import { UIModelType } from '../../constant';
import { getAllChildModels } from '../utils/merge-property';

const DEFAULT_SIZE = 0;

export default class MultiImageSize implements IImageSize {
    private model: IMultiplyModel;
    public constructor(model: IMultiplyModel) {
        this.model = model;
    }

    public getRelativeResize(): ImageRelativeResizeType {
        const { selectedModels } = this.model;
        if (!this.isAllImage()) return ImageRelativeResizeType.noRelative;
        const { relativeResize } = (selectedModels[0] as IPictureModel).props;
        const { length } = selectedModels;
        for (let index = 1; index < length; index++) {
            const picModel = selectedModels[index] as IPictureModel;
            if (relativeResize !== picModel.props.relativeResize) {
                return ImageRelativeResizeType.multi;
            }
        }
        return relativeResize === ImageRelativeResizeType.noRelative
            ? ImageRelativeResizeType.noRelative
            : ImageRelativeResizeType.isRelative;
    }

    public handleRelativeResize(value: number | boolean): void {
        if (!this.isAllImage()) return;
        transaction(() => {
            const { selectedModels } = this.model as IMultiplyModel;
            selectedModels.forEach((picModel: IPictureModel) => {
                picModel.updateProps({ relativeResize: value
                    ? ImageRelativeResizeType.isRelative
                    : ImageRelativeResizeType.noRelative,
                });
            });
        });
    }

    public resetSize(): void {
        const { selectedModels } = this.model;
        transaction(() => {
            selectedModels.forEach((model) => {
                if (model.type === UIModelType.IMAGE) {
                    (model as IPictureModel).getImageSize().resetSize();
                }
            });
        });
    }

    public getOriginalSize(): IOriginalSize {
        const selectedModels = getAllChildModels(this.model);
        const firstImage = selectedModels?.find(model => model.type === UIModelType.IMAGE
            && (model as IPictureModel).isImage());
        if (firstImage) {
            return (firstImage as IPictureModel).getImageSize().getOriginalSize();
        }
        return { width: DEFAULT_SIZE, height: DEFAULT_SIZE };
    }

    /**
     * 多选图片的前景大小展示默认值
     */
    public getForegroundImageSize = (): IForegroundSize => ({
        pl: DEFAULT_SIZE, pr: DEFAULT_SIZE, pt: DEFAULT_SIZE, pb: DEFAULT_SIZE,
        rw: DEFAULT_SIZE, rh: DEFAULT_SIZE,
    });

    /**
     * 多选图片不支持设置前景大小
     */
    public updateForegroundImageSize = (): void => {};

    private isAllImage = (): boolean => this.model.selectedModels.every(this.checkIsImage);

    private checkIsImage = (model: IElementBaseModel) => model.type === UIModelType.IMAGE
        && (model as IPictureModel).isImage();
}
